export default __webpack_public_path__ + "b7d059601106e4c424d7167e92183eeb.png";